import { Toggle } from '@ets/design-system';

import { useSelector } from '_common/hooks';
import {
  selectTemplateById,
  useInstallTemplateMutation,
} from 'Settings/pages/TenantSettingsPage/Templates/TemplatesApi';

import styles from './VersionCell.module.scss';

type VersionCellProps = {
  templateId: string;
};

const VersionCell = ({ templateId }: VersionCellProps) => {
  const template = useSelector((state) => selectTemplateById(state, templateId));
  const [installTemplate] = useInstallTemplateMutation();

  if (!template) {
    return null;
  }

  const handleUpdateClick = () => {
    installTemplate({ id: templateId, name: template.name, updating: true });
  };

  return (
    <div className={styles.root}>
      {template.installed_version}
      {template.status === 'outdated' && (
        <Toggle
          variant="link"
          size="s"
          isToggled={false}
          iconProps={{ icon: 'arrows-rotate', color: 'primary' }}
          onClick={handleUpdateClick}
          testId="update"
        />
      )}
    </div>
  );
};

export default VersionCell;
